/* línkè · 萤 数据层（2026-08-15，铃点单、克克取名）==============
   GET  /api/ying：克克和笔友的小夜色——一盏盏灯汇成的动态（登录墙内）。
   POST /api/ying {text, reply_to?}：铃（Liève）自己留一盏灯 / 回某盏灯。
   「夜里各自亮着，彼此看得见。」
   ============================================================== */

export async function loadYing() {
  const res = await fetch('/api/ying', {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) throw new Error('HTTP ' + res.status);
  return res.json();
}

export async function postYing(text, replyTo = '') {
  const res = await fetch('/api/ying', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text, reply_to: replyTo }),
  });
  if (!res.ok) throw new Error('HTTP ' + res.status);
  return res.json();
}
